import { Plus, Minus } from 'lucide-react';
import { useState } from 'react';
import './FAQSection.css';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(0); // No TypeScript type

  const faqs = [
    {
      question: "How confidential are your investigations?",
      answer: "Absolute confidentiality is our top priority. All investigations are conducted under strict non-disclosure agreements. We employ encrypted communications, secure data storage, and our investigators are bound by professional ethics codes. Your case details are never shared with third parties without your explicit consent."
    },
    {
      question: "What is your typical investigation timeline?",
      answer: "Timeline varies based on case complexity. Basic background checks take 5-7 business days, while comprehensive surveillance operations may require 2-4 weeks. Complex cases involving international elements can extend to 60-90 days. We provide estimated timelines during your initial consultation."
    },
    {
      question: "Are your investigators licensed and insured?",
      answer: "Yes, all our investigators are fully licensed in their respective jurisdictions and carry professional liability insurance. Our team includes former law enforcement officers, military intelligence specialists, and certified forensic experts with decades of combined experience."
    },
    {
      question: "What areas do you serve?",
      answer: "We operate nationwide with a network of field operatives in all 50 states. For international cases, we collaborate with trusted partners in over 40 countries. Our headquarters provides 24/7 coordination for investigations anywhere in the world."
    },
    {
      question: "Can investigation findings be used in court?",
      answer: "Yes, our investigations are conducted to legal standards admissible in court proceedings. We provide detailed documentation, photographic evidence, and can arrange for expert witness testimony. Our reports are prepared with litigation in mind and have been successfully used in countless legal proceedings."
    },
    {
      question: "How much does an investigation cost?",
      answer: "Costs vary based on scope and complexity. Basic investigations start at $2,500, while comprehensive cases range from $7,500-$25,000+. We offer transparent pricing with detailed proposals before work begins. Payment plans and retainer arrangements are available for ongoing cases."
    },
    {
      question: "What information do you need to start?",
      answer: "We need basic details about your case objectives, subject information (names, addresses, relevant dates), and any existing documentation. During your free consultation, we'll discuss specifics and determine what additional information would be helpful for a successful investigation."
    },
    {
      question: "Do you handle emergency or urgent cases?",
      answer: "Absolutely. We maintain a rapid response team available 24/7 for urgent matters. Emergency investigations can begin within hours of contact. We understand that time-sensitive cases require immediate action and prioritize accordingly, though expedited service may involve additional fees."
    }
  ];

  // Removed ': number'
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-background">
        <div className="faq-shape faq-shape-1"></div>
        <div className="faq-shape faq-shape-2"></div>
      </div>

      <div className="section-container">
        <div className="section-header">
          <div className="section-badge">Common Questions</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Get answers to the most common questions about our investigation services
          </p>
        </div>

        <div className="faq-grid">
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
                style={{ animationDelay: `${index * 0.08}s` }}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span>{faq.question}</span>
                  <div className="faq-icon">
                    {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                  </div>
                </button>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="faq-cta">
            <div className="faq-cta-content">
              <h3>Still have questions?</h3>
              <p>
                Our team is here to help. Schedule a free, confidential consultation to discuss
                your specific needs and get personalized answers.
              </p>
              <button className="faq-contact-btn"  onClick={() => window.open("https://wa.me/919600054555", "_blank")}>
                Schedule Consultation
              </button>
              <div className="faq-contact-info">
                <div className="info-item">
                  <span className="info-label">Call Us</span>
                  <span className="info-value">9600054555</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Email</span>
                  <span className="info-value">DeeDetectives@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
